import { render, staticRenderFns } from "./PracticeAncillaryServiceTestsPage.vue?vue&type=template&id=400aca2e&scoped=true"
import script from "./PracticeAncillaryServiceTestsPage.vue?vue&type=script&lang=js"
export * from "./PracticeAncillaryServiceTestsPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeAncillaryServiceTestsPage.vue?vue&type=style&index=0&id=400aca2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400aca2e",
  null
  
)

export default component.exports